// type UiNmberClickerInputProps = {value: number};

import { useRef, useState } from 'react';
import {
  ActionIcon,
  Group,
  NumberInput,
  NumberInputHandlers,
  rem,
} from '@mantine/core';
import { Minus, Plus } from 'tabler-icons-react';

export const UiNmberClickerInput = ({
  min,
  max,
  step = 1,
  disableEdit = false,
  value,
  defaultValue = 0,
  onChange,
}: {
  min?: number;
  max?: number;
  step?: number;
  disableEdit?: boolean;
  value?: number;
  defaultValue?: number;
  onChange?: (val: number) => void;
}) => {
  const [innerValue, setInnerValue] = useState<number | ''>(
    value || defaultValue
  );
  const handlers = useRef<NumberInputHandlers>();

  return (
    <Group spacing={5}>
      <ActionIcon
        size={42}
        variant="default"
        onClick={() => handlers.current?.decrement()}
      >
        <Minus />
      </ActionIcon>

      <NumberInput
        hideControls
        handlersRef={handlers}
        value={innerValue}
        onChange={(val) => {
          setInnerValue(val);
          onChange && onChange(Number(val));
        }}
        max={max}
        min={min}
        step={step}
        size="md"
        styles={{
          input: {
            width: rem(54),
            textAlign: 'center',
            ...(disableEdit && {
              ':disabled': {
                background: 'white',
                color: '#000',
                opacity: 1,
              },
            }),
          },
        }}
      />

      <ActionIcon
        size={42}
        variant="default"
        onClick={() => handlers.current?.increment()}
      >
        <Plus />
      </ActionIcon>
    </Group>
  );
};
